<template lang="pug">
  .pdp-carousel
    .the-carousel(:class="{'has-arrows': hasArrows}")
      slick(v-if="!hideCarousel && carouselImages.length > 1" ref="slick" v-bind="carouselOptions" :key="`carousel-${getImagesListKey(images)}`")
        .slide(v-for="image in carouselImages" :key="'mobile-carousel-' + getImageKey(image)")
          .img.a-box-xs-4x3.a-box-md-4x3
            .a-box-content.bg-fog-light
              img-box.full-width(:media-obj="image" :alt="image.alt_text" itemprop="image")

      button.bottom-left-nav.btn-reset(v-if="hasArrows" type="button" @click="prev")
        span.icon-caret-left.text-color-2.xs-f-large.max-at-tweak.non-focusable(tabindex="-1")
          span.ada-tooltip previous
      .bottom-nav
        slick.bottom-slider-nav(v-if="!hideCarousel && carouselImages.length > 1" ref="slickNavBottom" v-bind="bottomCarouselNavOptions" :key="`bottomNav-${getImagesListKey(images)}`")
          .bottom-slide(v-for="image in carouselImages" :key="'bottom-nav-' + getImageKey(image)")
            .bottom-img
              .a-box-xs-1x1
                .a-box-content.bg-fog-light
                  img-box.full-width(:media-obj="image" :alt="image.alt_text" itemprop="image")

      button.bottom-right-nav.btn-reset(v-if="hasArrows" type="button" @click="next")
        span.icon-caret-right.text-color-2.xs-f-large.max-at-tweak.non-focusable(tabindex="-1")
          span.ada-tooltip next
</template>

<script>
  import { mapActions } from 'vuex';
  import ImgBox from '@components/imgBox';
  import CarouselNavItem from '@components/PDP/PdpCarousel/CarouselNavItem/CarouselNavItem';

  export default {
    name: 'HCBLocationsHeroCarousel',

    components: {
      ImgBox,
      CarouselNavItem,
    },

    props: {
      images: {
        type: Array,
        default: () => [],
      },
      navSlidesToShow: {
        type: Number,
        required: false,
        default: 5,
      },
    },

    data: () => ({
      navRef: undefined,
      carouselRef: undefined,
      currentSlideIndex: 0,
      hideCarousel: true
    }),

    computed: {
      //- have to filter out any null images that are possible because of cms bug
      carouselImages() {
        return this.images.filter(img => !!img);
      },

      carouselClass() {
        return 'slider-for-' + this.$.uid;
      },

      carouselOptions() {
        return {
          accessibility: true,
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: false,
          asNavFor: this.navRef,
          lazyLoad: 'progressive',
          autoplay: false,
          responsive: [
            {
              breakpoint: 760,
              settings: {
                fade: false,
                infinite: true,
                swipeToSlide: true,
              },
            },
          ],
        };
      },

      bottomCarouselNavOptions() {
        return {
          slidesToShow: 6,
          slidesToScroll: 1,
          focusOnSelect: true,
          arrows: false,
          dots: false,
          vertical: false,
          accesibility: true,
          infinite: true,
          asNavFor: this.carouselRef,
          autoplay: false,
          initialSlide: this.currentSlideIndex,
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 760,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1,
                fade: false,
                infinite: true,
                swipeToSlide: true,
              }
            }
          ]
        };
      },

      hasArrows() {
        let slidesQty = this.carouselImages.length;

        return slidesQty > this.navSlidesToShow;
      },
    },

    watch: {
      carouselImages: {
        immediate: true,
        handler() {
          this.hideCarousel = true;

          this.$nextTick(() => {
            this.hideCarousel = false;
            this.$nextTick(() => {
              this.navRef = this.$refs.slickNavBottom || null;
              this.carouselRef = this.$refs.slick;
            });
          });
        }
      }
    },

    methods: {
      ...mapActions('modal', ['showModal']),

      onSlideChange(oldSlideIndex, newSlideIndex) {
        this.currentSlideIndex = newSlideIndex;
      },

      next() {
        this.carouselRef.next();
      },

      prev() {
        this.carouselRef.prev();
      },

      getImageKey(image = {}) {
        return image.mediaId || image.url;
      },

      getImagesListKey(images = []) {
        return images.map(this.getImageKey).join(',');
      },
    },
  };
</script>

<style lang="stylus">
  .pdp-carousel
    width 100%
    overflow hidden

    .the-carousel
      .slide
        padding 0 0.5em

        .a-box-content
          border-radius 8%

    .bottom-nav
      position relative
      .bottom-slider-nav
        padding 0.5em
        .slick-slider
          .slick-slide
            padding 0.5em

            .bottom-img
              border-radius 20%

              .a-box-content
                border-radius 20%
          .slick-current
            .bottom-img
              outline 3px solid brand-color-2

    @media mq-mobile
      .the-carousel
        display block
        width 100%

        .bottom-nav
          .slick-track
            margin-left 14%

        .left-nav
        .right-nav
          position absolute
          width 10%
          top 0
          bottom 0

        .left-nav
          left -10%

        .right-nav
          right -10%
          overflow visible !important

          .slick-list
            overflow visible !important

    @media mq-tablet
      .carousel-wrap
        display block
        margin 0 auto

        .left-nav
        .right-nav
          position absolute
          width 10%
          top 0
          bottom 0

        .left-nav
          left 0

        .right-nav
          right 0


          overflow visible !important

          .slick-list
            overflow visible !important

    @media mq-desktop-md-plus
      .bottom-nav
        padding 2% 0
        position relative

        .slick-slider
          margin-bottom 0

        &.has-arrows
          padding 2% 1.75em

          .bottom-right-nav
          .bottom-left-nav
            height 100%
            position absolute
            top 50%
            transform translateY(-50%)

          .bottom-right-nav
            right 0

          .bottom-left-nav
            left 0

        .bottom-slide
          padding 0.3em

      .carousel-wrap
        width 100%

        &.nav-on-side
          width 80%
          margin-left 20%

        .left-nav
        .right-nav
          display none

    @media only screen and (min-width: 560px) and (max-width: 768px)
      .bottom-nav
        .bottom-slider-nav
          max-height 5em !important
          overflow hidden !important

    @media only screen and (min-width: 769px) and (max-width: 1024px)
      .bottom-nav
        .bottom-slider-nav
          max-height 6em !important
          overflow hidden !important
    
    @media only screen and (min-width: 1025px)
      .bottom-nav
        .bottom-slider-nav
          max-height 8em !important
          overflow hidden !important
</style>
